
export default class SelectService {

    public static selectList($axios, file) {
        return $axios.$get('/select/' + file + '/selectList');
    }

}
